module.exports = __webpack_public_path__ + "img/mastercard.ca84608d.svg";